import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import { assembleName, generateLabel } from './util';

export interface IGuarantorBadgeProps {
    className?: string;
    id?: string;
    first?: string;
    last?: string;
    suffix?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
    openInNewTab?: boolean;
}
export const GuarantorBadge: React.FunctionComponent<IGuarantorBadgeProps> = (
    props: IGuarantorBadgeProps,
): React.ReactElement => {
    const { className, id, first, last, suffix, tooltip, items = [] } = props;
    const name = assembleName(first, last, suffix);
    const defaultItems: IActionMenuBadgeItem[] = [...items];
    return (
        <ActionMenuBadge
            className={className}
            label={generateLabel('Guarantor', id, name)}
            tooltip={tooltip}
            items={defaultItems}
            id={id}
        />
    );
};
